export enum PayWith {
	'CARD' = 'CARD', // Pay with Credit/Debit Card
	'BM' = 'BM', // Pay with Bank Muscat
}

export interface BasePaymentToken {
	id: string;
	tokenType: PayWith;
	default: boolean;
	isUnSaved?: boolean;
}

export interface CardPaymentToken extends BasePaymentToken {
	firstName: string;
	lastName: string;
	cardNumber: string;
	cardType: string;
	paymentGateway: 'C';
	cardExpiry: string;
	daysTillExpiry: number;
	bankName: string;
	cardCVV?: string;
	savedOption?: boolean;
}

export interface BOMPaymentToken extends BasePaymentToken {
	mobileNumber: string;
	paymentAliasId: string;
	savedOption?: boolean;
}

export interface PaymentTokenResponse {
	defaultMethod: PayWith;
	tokens: Array<CardPaymentToken | BOMPaymentToken>;
}

export interface Token<T> {
	defaultToken: T | undefined;
	tokens: T[];
}

export interface UseGetPaymentTokens {
	defaultMethod: PayWith;
	cards: Token<CardPaymentToken>;
	BOM: Token<BOMPaymentToken>;
	refresh: () => void;
	loading: boolean;
}

export interface CardDetails {
	name: string;
	cardNumber: string;
	cardExpire: string;
	cardCVV: string;
	savedOption?: boolean;
}

export interface CardPaymentDetails {
	email: string;
	defaultOption: boolean;
}

export interface BankPaymentDetails {
	mobile: string;
	paymentAlias: string;
	savedOption?: boolean;
}

export interface BankDetails {
	savedOption: boolean;
	defaultOption: boolean;
	agreeTermCondition: boolean;
}

export interface CardPayment extends types.payment.MakePayment {
	flowType: 'OMANNET_PREFFERRED';
}

export interface BankPayment extends types.payment.BankPayment {
	flowType: 'BANK_MUSCAT';
}

export type MakePaymentProps = CardPayment | BankPayment;

export interface PaymentSummary {
	data: Data;
}

export interface Data {
	totalAmount: TotalAmount;
	paymentSummaryMonthlyItems: MonthlyPaymentItem[];
}

export interface TotalAmount {
	unit: string;
	value: number;
}

export interface MonthlyPaymentItem {
	month: string;
	year: string;
	totalAmount: TotalAmount;
	paymentSummaryBillDetails: BillDetail[];
}

export interface BillDetail {
	accountId: string;
	billNumber: string;
	amount: TotalAmount;
}

export interface BillItem extends Omit<types.payment.paymentItem, 'type'> {
	type: string;
}

export enum PaymentStatusType {
	'SUCCESS' = 'SUCCESS',
	'INITIATED' = 'INITIATED',
	'ERROR' = 'ERROR',
	'FAILED' = 'FAILED',
	'REJECTED' = 'REJECTED',
	'TIME_OUT' = 'TIME_OUT',
	'CREDIT_EXCEEDS_MAX' = 'CREDIT_EXCEEDS_MAX',
	'DEBIT_EXCEEDS_MAX' = 'DEBIT_EXCEEDS_MAX',
}

export interface PaymentMethodProps {
	bills: BillItem[];
	paymentPreference?: PayWith;
	/**
	 * Callback function invoked after a payment attempt.
	 *
	 * @param {PaymentStatusType} result - The result of the payment attempt.
	 */
	// eslint-disable-next-line no-unused-vars
	onPaymentResult?: (result: PaymentStatusType, data?: unknown) => void;
	referrer?: string;
}
